import { render, staticRenderFns } from "./question-view.vue?vue&type=template&id=5aceb18e&scoped=true"
import script from "./question-view.vue?vue&type=script&lang=js"
export * from "./question-view.vue?vue&type=script&lang=js"
import style0 from "./question-view.vue?vue&type=style&index=0&id=5aceb18e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5aceb18e",
  null
  
)

export default component.exports